import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { Button } from '@flipster/react/design-system/button';
import { Datetime } from '@flipster/react/design-utils/datetime';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';

import { competitionBunja, registerCompetitionBunja } from '../bunja';

export const RegisterNowButton = () => {
  const t = useTranslations();
  const { register, isRegistrationPendingAtom } = useBunja(registerCompetitionBunja);
  const { competitionAtom, registrationStatusAtom } = useBunja(competitionBunja);
  const isRegistrationPending = useAtomValue(isRegistrationPendingAtom);
  const competition = useAtomValue(competitionAtom);
  const registrationStatus = useAtomValue(registrationStatusAtom);
  return (
    <div className={center({ flexDir: 'column', gap: 8, p: 30, bg: 'gray.black' })}>
      <Button
        withSpinner
        onClick={register}
        label={t('Autogen_common.r251126.s_Register_Now')}
        disabled={isRegistrationPending}
        css={{ minW: { base: '100%', tablet: 300 } }}
      />
      {!registrationStatus?.isEnd && !competition?.participationTime && (
        <p className={css({ textStyle: 'Text/M/Monospace/Regular', color: 'content.default.level-3' })}>
          Ends on <Datetime value={competition?.registrationEndTime} format='LLL dd, yyyy' isUTC />
        </p>
      )}
    </div>
  );
};
